"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.typographyWithDigitalHig = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Typography = _interopRequireDefault(require("@mui/material/Typography"));

var _material = require("@mui/material");

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var typographyWithDigitalHig = function typographyWithDigitalHig(BaseMuiTypography) {
  var Typography = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
    var children = _ref.children,
        className = _ref.className,
        color = _ref.color,
        style = _ref.style,
        tabularNumeric = _ref.tabularNumeric,
        variant = _ref.variant,
        otherProps = _objectWithoutProperties(_ref, ["children", "className", "color", "style", "tabularNumeric", "variant"]);

    var muiApiPresets = {// align
      // children
      // classes
      // component
      // gutterBottom
      // noWrap
      // paragraph
      // sx
      // variant
      // variantMapping
    };
    var theme = (0, _material.useTheme)();
    var classnames = className && className.split(" ") || [];
    tabularNumeric && classnames.push("dhig-typography-tabular-numeric"); // Default set in theme data. Header variant type overrides this, and color prop overrides that.

    var colorStyle = {};

    if (variant && (variant.includes("display") || variant.includes("headline"))) {
      colorStyle = {
        color: theme.tokens.colors["ink-on-background"].rgb
      };
    }

    if (color) {
      colorStyle = {
        color: theme.tokens.colors[color].rgb
      };
    }

    return /*#__PURE__*/_react.default.createElement(BaseMuiTypography, _extends({}, muiApiPresets, {
      className: classnames.join(" "),
      ref: ref,
      style: _objectSpread(_objectSpread({}, style), colorStyle),
      variant: variant
    }, otherProps), children);
  });

  Typography.displayName = "Typography";
  Typography.defaultProps = {
    component: "p",
    variant: "body-copy-medium",
    tabularNumeric: false
  };
  Typography.propTypes = {
    /**
     * The text content
     */
    children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.string]).isRequired,

    /**
     * Class names to apply to the typography component
     */
    className: _propTypes.default.string,

    /**
     * DHIG Typography text colors
     */
    color: _propTypes.default.oneOf(_constants.availableColors),

    /**
     * MUI component prop, determines HTML element used
     */
    component: _propTypes.default.string,

    /**
     * Additional styles
     */
    style: _propTypes.default.object,

    /**
     * DHIG Typography tokens
     */
    variant: _propTypes.default.oneOf(_constants.availableVariants),

    /**
     * DHIG Tabular numeric, displays a set of figures where numbers are all of the same size, allowing them to be easily aligned like in tables.
     */
    tabularNumeric: _propTypes.default.bool
  };
  return Typography;
};

exports.typographyWithDigitalHig = typographyWithDigitalHig;
var Typography = typographyWithDigitalHig(_Typography.default);
var _default = Typography;
exports.default = _default;